import { type ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

type GlassLevel = 'hero' | 'content' | 'light';

interface GlassCardProps {
  level?: GlassLevel;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
}

const levelClasses: Record<GlassLevel, string> = {
  hero: 'glass-hero rounded-glass',
  content: 'glass-content rounded-glass-sm',
  light: 'bg-white/40 backdrop-blur-[8px] border border-white/55 rounded-glass-sm',
};

export function GlassCard({ level = 'content', className, children, onClick }: GlassCardProps) {
  return (
    <div className={cn('p-4', levelClasses[level], className)} onClick={onClick}>
      {children}
    </div>
  );
}
